import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import LiveList from "./components/LiveList";
import BootstrapMenuBar from "./components/menu/BootstrapMenuBar";
import Login from "./components/login-config/Login";
import LoginHandler from "./components/login-config/LoginHandler";
import Report from "./components/login-config/Report";
import ChangeLogin from "./components/login-config/ChangeLogin";
import Configuration from "./components/login-config/Configuration";
import Inventory from "./components/Inventory";
import Ports from "./components/Ports";
import MediaCounters from "./components/MediaCounters";
import InterfaceCounters from "./components/InterfaceCounters";
import Network from "./components/Network";
import PingGraph from "./components/PingGraph";
import TSExpert from "./components/ts-expert/TSExpert";
import EventLog from "./components/EventLog";
import TsExpertConfig from "./components/login-config/TsExpertConfig";
import OfficeEthernetConfig from "./components/login-config/OfficeEthernetConfig";
import EthernetConfig from "./components/login-config/EthernetConfig";
import WLANConfig from "./components/login-config/WLANConfig";
import Sweep from "./components/login-config/Sweep";
import Topology from "./components/Topology";
import Constants from "./components/utilities/Constants";
import GraphicTopology from "./components/GraphicTopology";
import Utils from "./components/utilities/Utils";

const UtilsInstance = new Utils();
class App extends Component {

  componentDidMount = async () => {
    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      const language = await fetch(Constants.REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data.language)
        .catch(() => Constants.PT_LANG_KEY);

      localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
      window.location.reload();
      return;
    }

    let ethernetPresent = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiOrEthernet", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.ethernetPresent);
    sessionStorage.setItem(Constants.WIFI_OR_ETHENET_KEY, ethernetPresent);
  }
  
  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <BootstrapMenuBar />
          <Route exact path="/" component={TSExpert} />
          <Route exact path="/liveList" component={LiveList} />
          <Route path="/config" component={Configuration} />
          <Route path="/login" component={Login} />
          <Route path="/login-handler" component={LoginHandler} />
          <Route path="/report" component={Report} />
          <Route path="/change-login" component={ChangeLogin} />
          <Route path="/inventory" component={Inventory} />
          <Route path="/ports" component={Ports} />
          <Route path="/mediaCounters" component={MediaCounters} />
          <Route path="/interfaceCounters" component={InterfaceCounters} />
          <Route path="/network" component={Network} />
          <Route path="/pingGraph" component={PingGraph} />
          <Route path="/topology" component={Topology} />
          <Route path="/log" component={EventLog} />
          <Route path="/ethernet-config" component={EthernetConfig} />
          <Route path="/wlan-config" component={WLANConfig} />
          <Route path="/sweep" component={Sweep} />
          <Route path="/ts-expert-config" component={TsExpertConfig} />
          <Route path="/office-ethernet-config" component={OfficeEthernetConfig} />
          <Route path="/graphic-topology" component={GraphicTopology} />
        </div>
      </Router>
    );
  }
}

export default App;
